<template>
  <div>
    <b-input-group class="wrap-view domain-form" size="sm">
      <b-form-input v-model="query.domain" squared placeholder="请填写域名"></b-form-input>
      <b-input-group-append>
        <b-button variant="primary" squared @click="relocate" :disabled="loading"><i v-if="loading" class="mr-1 el-icon-loading"></i>提交检测</b-button>
      </b-input-group-append>
    </b-input-group>
    <box>
      <span slot="header" class="p-3 font-weight-bold">基础信息</span>
      <div class="field-wrap">
        <div class="field">
          <div class="text-wrap label">GEO地理位置：</div>
          <div class="text-wrap">
            <template v-if="base.geo">{{base.geo}}</template>
            <i v-else class="el-icon-loading"></i>
          </div>
        </div>
      </div>
      <div class="field-wrap">
        <div class="field">
          <div class="text-wrap label">公网出口IP：</div>
          <div class="text-wrap">
            <template v-if="base.ip">{{base.ip}}</template>
            <i v-else class="el-icon-loading"></i>
          </div>
        </div>
      </div>
      <div class="field-wrap">
        <div class="field">
          <div class="text-wrap label">探测时间：</div>
          <div class="text-wrap">
            <template v-if="base.timestamp">{{base.timestamp}}</template>
            <i v-else class="el-icon-loading"></i>
          </div>
        </div>
      </div>
    </box>
    <box v-if="domain.target">
      <span slot="header" class="p-3 font-weight-bold">以下是您填写域名的测试结果</span>
      <div class="field-wrap">
        <div class="field half">
          <div class="text-wrap label">域名：</div>
          <div class="text-wrap">{{domain.target}}</div>
        </div>
        <div class="field half">
          <div class="text-wrap label">LDNS解析IP：</div>
          <div class="text-wrap">
            <template v-if="domain.ldns">{{domain.ldns}}</template>
            <i v-else class="el-icon-loading"></i>
          </div>
        </div>
      </div>
      <!--TODO 其他检测信息展示-->
      <div class="field-wrap">
        <div class="field half">
          <div class="text-wrap label">加载延时：</div>
          <div class="text-wrap">
            <template v-if="domain.delay">{{domain.delay}}</template>
            <i v-else class="el-icon-loading"></i>
          </div>
        </div>
        <div class="field half">
          <div class="text-wrap label">服务器拨测：</div>
          <div class="text-wrap">
            <template v-if="domain.ping">{{domain.ping}}</template>
            <i v-else class="el-icon-loading"></i>
          </div>
        </div>
      </div>
      <div class="field-wrap">
        <div class="field half">
          <div class="text-wrap label">HTTP支持：</div>
          <div class="text-wrap">
            <template v-if="domain.http">{{domain.http}}</template>
            <i v-else class="el-icon-loading"></i>
          </div>
        </div>
        <div class="field half">
          <div class="text-wrap label">HTTPS支持：</div>
          <div class="text-wrap">
            <template v-if="domain.https">{{domain.https}}</template>
            <i v-else class="el-icon-loading"></i>
          </div>
        </div>
      </div>
    </box>
    <box>
      <span slot="header" class="p-3 font-weight-bold">以下是您操作系统相关信息</span>
      <div v-for="(fieldRow,i) in navigatorFields" :key="i" class="field-wrap">
        <div v-for="(field,j) in fieldRow" :key="j" class="field" :class="{half:fieldRow.length===2}">
          <div class="text-wrap label">{{field.label}}：</div>
          <div class="text-wrap">
            <template v-if="navigator[field.value]">{{navigator[field.value]}}</template>
            <i v-else class="el-icon-loading"></i>
          </div>
        </div>
      </div>
    </box>
    <box>
      <span slot="header" class="p-3 font-weight-bold">以下是汽车之家域名测试结果</span>
      <div v-for="(domain,i) in domainsATHM" :key="i" class="field-wrap">
        <div class="field">
          <div class="text-wrap domain">{{domain}}：</div>
          <div class="text-wrap">
            <template v-if="!!domainsDelayResult[domain]">{{formatDelay(domainsDelayResult[domain])}}</template>
            <i v-else class="el-icon-loading"></i>
          </div>
        </div>
      </div>
    </box>
    <box>
      <span slot="header" class="p-3 font-weight-bold">以下是其他域名测试结果</span>
      <div v-for="(domain,i) in domainsOther" :key="i" class="field-wrap">
        <div class="field">
          <div class="text-wrap domain">{{domain}}：</div>
          <div class="text-wrap">
            <template v-if="!!domainsDelayResult[domain]">{{formatDelay(domainsDelayResult[domain])}}</template>
            <i v-else class="el-icon-loading"></i>
          </div>
        </div>
      </div>
    </box>
    <box>
      <span slot="header" class="p-3 font-weight-bold">问题反馈</span>
      <b-form ref="form" @submit="handleSubmit">
        <b-form-group id="input-name-label" label-size="sm" label-cols="12" label-cols-sm="2" label-cols-lg="1" label-align-sm="right" label="姓名" label-for="input-name" :state="validator.validate('name').state" :invalid-feedback="validator.validate('name').message">
          <b-form-input id="input-name" size="sm" v-model="form.name" placeholder="请填写姓名"></b-form-input>
        </b-form-group>
        <b-form-group id="input-phone-label" label-size="sm" label-cols="12" label-cols-sm="2" label-cols-lg="1" label-align-sm="right" label="联系电话" label-for="input-phone" :state="validator.validate('phone').state" :invalid-feedback="validator.validate('phone').message">
          <b-form-input id="input-phone" size="sm" v-model="form.phone" placeholder="请填写联系电话"></b-form-input>
        </b-form-group>
        <b-form-group id="input-qq-label" label-size="sm" label-cols="12" label-cols-sm="2" label-cols-lg="1" label-align-sm="right" label="QQ" label-for="input-qq" :state="validator.validate('qq').state" :invalid-feedback="validator.validate('qq').message">
          <b-form-input id="input-qq" size="sm" v-model="form.qq" placeholder="请填写QQ"></b-form-input>
        </b-form-group>
        <b-form-group id="input-wechat-label" label-size="sm" label-cols="12" label-cols-sm="2" label-cols-lg="1" label-align-sm="right" label="微信" label-for="input-wechat" :state="validator.validate('wechat').state" :invalid-feedback="validator.validate('wechat').message">
          <b-form-input id="input-wechat" size="sm" v-model="form.wechat" placeholder="请填写微信"></b-form-input>
        </b-form-group>
        <b-form-group id="input-email-label" label-size="sm" label-cols="12" label-cols-sm="2" label-cols-lg="1" label-align-sm="right" label="邮箱地址" label-for="input-email" :state="validator.validate('email').state" :invalid-feedback="validator.validate('email').message">
          <b-form-input id="input-email" size="sm" v-model="form.email" placeholder="请填写邮箱地址"></b-form-input>
        </b-form-group>
        <b-form-group id="input-desc-label" label-size="sm" label-cols="12" label-cols-sm="2" label-cols-lg="1" label-align-sm="right" label="问题描述" label-for="input-desc" :state="validator.validate('desc').state" :invalid-feedback="validator.validate('desc').message">
          <b-form-textarea id="input-desc" size="sm" v-model="form.desc" placeholder="请填写问题描述" rows="3" max-rows="6"></b-form-textarea>
        </b-form-group>
        <div class="text-center">
          <b-button size="sm" type="submit" variant="primary" squared>提交反馈</b-button>
        </div>
      </b-form>
    </box>
  </div>
</template>

<script>
  import PageBase from '@/util/mixins/page-base'
  import Box from '@/util/views/box'
  import UUID from '@/util/scripts/uuid'
  import {Validator, validateDomain, validateEmail, validatePhone, validateLength} from '@/util/scripts/validator'
  import service from '../scripts/service'
  import {checkGEO} from '../scripts/check-geo'
  import {checkIP} from '../scripts/check-ip'
  import {checkSubmitDomain} from '../scripts/check-submit-domain'
  import {checkNavigator, navigatorFields} from '../scripts/check-navigator'
  import {checkDomains, domainsATHM, domainsOther, formatDelay} from '../scripts/check-domains'

  const validateContact = (value, form) => {
    let state = !!form.phone || !!form.email || !!form.qq || !!form.wechat
    let message = state ? '' : '请至少填写一种联系方式'
    return {state, message}
  }

  export default {
    name: 'webcheck',
    mixins: [PageBase],
    components: {Box},
    data() {
      return {
        formatDelay,
        storage: this.localStorage('ATHM-WebCheck', support => ({uuid: UUID()})),
        //基础信息
        geoCheckPromise: null, ipCheckPromise: null,
        base: {geo: '', ip: '', timestamp: ''},
        //用户提交域名检测
        query: {domain: ''},
        domain: {target: '', delay: '', ping: '', ldns: '', http: '', https: ''},
        //操作系统相关信息
        navigatorFields, navigator: {},
        //汽车之家域名 & 其他域名 测试
        domainsCheckPromise: null,
        domainsATHM, domainsOther, domainsDelayResult: {},
        //用户反馈
        form: {name: '', phone: '', qq: '', wechat: '', email: '', desc: ''},
        validator: new Validator(this, 'form', {
          name: [{required: true, message: '请填写姓名', validate: validateLength({min: 2})}],
          phone: [{validate: validateContact, force: true}, {validate: validatePhone}],
          qq: [{validate: validateContact, force: true}],
          wechat: [{validate: validateContact, force: true}],
          email: [{validate: validateContact, force: true}, {validate: validateEmail}],
          desc: [{required: true, message: '请填写问题描述', validate: validateLength({min: 5})}]
        })
      }
    },
    mounted() {
      //操作系统相关信息
      this.navigator = checkNavigator()
      //GEO地理位置 result = {geo,timestamp}
      this.geoCheckPromise = checkGEO().then(result => Object.assign(this.base, result))
      //公网出口IP
      this.ipCheckPromise = checkIP().then(ip => Object.assign(this.base, {ip}))
      //汽车之家域名 & 其他域名 测试
      this.domainsCheckPromise = checkDomains((domain, delay, type) => this.$set(this.domainsDelayResult, domain, {delay, type}))
      //上报
      Promise.all([
        this.geoCheckPromise, this.ipCheckPromise, this.domainsCheckPromise
      ]).then(([geo, ip, delays]) => {
        service.report({
          uuid: this.storage.uuid,
          reportdata: JSON.stringify({base: Object.assign({}, geo, ip), delays, navigator: this.navigator})
        })
      })
    },
    methods: {
      handleRouteChange() {
        let domain = this.query.domain
        if (domain === '') return
        if (!validateDomain(domain).state) return this.$message.error('填写域名不合法，请检查填写的域名是否正确')
        this.loading = true
        this.domain = {target: domain, delay: '', ping: '', ldns: '', http: '', https: ''}
        //用户输入域名检测&上报
        Promise.all([
          this.geoCheckPromise, this.ipCheckPromise, this.domainsCheckPromise,
          checkSubmitDomain(domain, (result) => Object.assign(this.domain, result))
        ]).then(([geo, ip, delays, domain]) => {
          setTimeout(() => this.loading = false, 1000)
          service.report({
            uuid: this.storage.uuid,
            reportdata: JSON.stringify({
              base: Object.assign({}, geo, ip),
              delays, domain,
              navigator: this.navigator
            })
          })
        })
      },
      //用户反馈
      handleSubmit(e) {
        e.preventDefault()
        let pass = this.validator.validateForm()
        if (!pass) return
        service.feedback(Object.assign({uuid: this.storage.uuid}, this.form))
          .then(({success, message}) => {
            if (success) {
              this.$message.success('反馈信息提交成功')
              this.form = {name: '', phone: '', email: '', desc: ''}
              this.validator.reset()
            } else this.$message.error(message)
          })
          .catch(e => this.$message.error('反馈信息提交失败'))
      }
    }
  }
</script>

<style lang="scss" scoped>
  .domain-form {
    justify-content: flex-end;

    .form-control {
      display: inline-block;
      width: calc(100% - 5.2rem);
      max-width: 20rem;
      vertical-align: middle;
    }
  }

  .field-wrap {
    overflow: hidden;

    .field {
      vertical-align: top;

      &.half {
        width: 50%;
        display: inline-block;
      }
    }
  }

  .field-wrap + .field-wrap {
    margin-top: 1rem;
  }

  .text-wrap {
    padding: 0 1rem;
    line-height: 1rem;
    vertical-align: top;
    display: inline-block;
  }

  .text-wrap.label {
    min-width: 8.5rem;
    font-weight: 500;
  }

  .text-wrap.domain {
    min-width: 13.5rem;
    font-weight: 500;
  }
</style>